module.exports = __webpack_public_path__ + "static/Curbix-1-bcf2a4b23493cb9cde219727488d5c33.jpg";